import { Component, OnInit } from "@angular/core";
import { Title, Meta } from "@angular/platform-browser";
import { HeaderService } from "@rubbl-layout";

@Component({
  selector: "app-list-your-machines-layout",
  templateUrl: "./list-your-machines-layout.component.html",
  styleUrls: ["./list-your-machines-layout.component.scss"],
})
export class ListYourMachinesLayoutComponent implements OnInit {
  constructor(private titleService: Title, private meta: Meta, private headerService: HeaderService) {
    this.titleService.setTitle("Make Money With Your Idle Equipment | Rubbl");
    this.meta.addTag({ name: "description", content: "Rent construction and heavy machine equipment and earn more with Rubbl." });
  }

  ngOnInit(): void {
    this.headerService.showDefaultHeaderItems();
  }
}
